import React from 'react';

const SvgDashboard = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path
      d="M20.65 4.3a.7.7 0 00-.71-.69H4.06a.7.7 0 00-.71.69v15.4a.7.7 0 00.71.69h15.88a.7.7 0 00.71-.69v-10zm-1.41.7v4h-6.53V5zm-7.95 0v8.61H4.76V5zM4.76 15h6.53v4H4.76zm8 4.06v-8.65h6.53V19z"
      fill="#989898"
    />
  </svg>
);

export default SvgDashboard;
